import { createContext, useContext, useState } from "react";

const ChatSettingsContext = createContext();

export const ChatSettingsProvider = ({ children }) => {
  const [bgColor, setBgColor] = useState("#f8f6ff");

  return (
    <ChatSettingsContext.Provider value={{ bgColor, setBgColor }}>
      {children}
    </ChatSettingsContext.Provider>
  );
};

export const useChatSettings = () => useContext(ChatSettingsContext);
